import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';
import { LocationChangeDispatcher } from '@piwikpro/router-crate';

const SecuredLayout = withInject({
  Secured: 'AuthCrate.components.Secured',
})(({ Secured }: any) => (
  <Secured>
    <LocationChangeDispatcher />
    <Outlet />
  </Secured>
));

export const Route = createFileRoute('/_secured')({
  component: SecuredLayout,
});
